import { inject, injectable } from "inversify";
import { IMostrarControleDebitoUseCase } from "../ports/MostrarControleDebito";
import { ContabilDITypes } from "@/features/contabil/services/types";
import { type IMostrarControleDebitosGateway } from "../ports/MostrarControleDebitosGateway";

@injectable()
export default class MostrarControleDebitoUseCase
  implements IMostrarControleDebitoUseCase
{
  @inject(ContabilDITypes.MOSTRAR_CONTROLE_DEBITOS_GATEWAY)
  private gateway!: IMostrarControleDebitosGateway;

  async podeExibir(): Promise<boolean> {
    try {
      const result = await this.gateway.get();

      return result.temDebitoSimples;
    } catch (_e) {
      return false;
    }
  }
}
